import {
  CurrencyPair,
  CurrencyPairPart,
  Flex,
  ProductTypeEnum,
  SecuritiesRenderer,
  SecurityTypesUtils,
  SyntheticProductTypeEnum,
  areBothLegsSpot,
  hasSyntheticProductType,
  isSecurityCME,
  useSecuritiesContext,
} from '@talos/kyoko';
import { memo } from 'react';
import type { SymbolDisplayProps } from './types';

export const SYMBOL_DISPLAY_HEADER_TEST_ID = 'symbol-display-header';
export const SymbolHeader = memo(
  ({
    security,
    quoteCurrencies,
    unifiedLiquidity,
    availableSymbols,
    compoundInstrumentLegSymbols,
  }: SymbolDisplayProps) => {
    const { securitiesBySymbol } = useSecuritiesContext();

    if (!security) {
      // Either something is wrong, or
      if (compoundInstrumentLegSymbols) {
        return <SecuritiesRenderer symbols={compoundInstrumentLegSymbols} showIcon />;
      } else {
        return null; // something is wrong / haven't loaded stuff yet
      }
    }

    // A bunch of different cases where we want to show the Security.DisplaySymbol instead of rendering the different relevant currencies
    const showDisplaySymbol =
      (!hasSyntheticProductType(security) && security.ProductType === ProductTypeEnum.Basis) ||
      (hasSyntheticProductType(security) &&
        (security.MultilegDetails?.SyntheticProductType !== SyntheticProductTypeEnum.Cross ||
          !areBothLegsSpot(security, securitiesBySymbol))) ||
      isSecurityCME(security) ||
      security.ProductType === ProductTypeEnum.ExchangeTradedFund ||
      security.ProductType === ProductTypeEnum.Compound;

    return (
      <Flex data-testid={SYMBOL_DISPLAY_HEADER_TEST_ID}>
        {SecurityTypesUtils.Option.isType(security) && !isSecurityCME(security) ? (
          <CurrencyPairPart security={security} currency={security.BaseCurrency} />
        ) : (
          <CurrencyPair
            security={security}
            data-testid="currency-pair"
            quoteCurrencies={quoteCurrencies}
            unifiedLiquidity={unifiedLiquidity}
            availableSymbols={availableSymbols}
            showDisplaySymbol={showDisplaySymbol}
          />
        )}
      </Flex>
    );
  }
);
